module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_sand_5-5d65fc2c07eeb800d0e882dbe3fe1139.png";